












































import { mapGetters } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import TableRow from '@/components/TableRow.vue'
import OrderRouteTableCells from '@/components/new-design/OrderRouteTableCells.vue'
import OrderSpecificationsTableCell from '@/components/new-design/OrderSpecificationsTableCell.vue'
import TransportRequestStatusTableCell from '@/components/new-design/TransportRequestStatusTableCell.vue'
import OrderNetEarningsTableCell from '@/components/OrderNetEarningsTableCell.vue'
import OrderPalletExchangeTableCell from '@/components/OrderPalletExchangeTableCell.vue'
import OrderActionsButtonTableCell from './OrderActionsButtonTableCell.vue'

export default {
  components: {
    TableRow,
    OrderRouteTableCells,
    OrderSpecificationsTableCell,
    TransportRequestStatusTableCell,
    OrderNetEarningsTableCell,
    OrderPalletExchangeTableCell,
    OrderActionsButtonTableCell
  },
  props: {
    order: { type: Object, required: true },
    multiStop: { type: Object, required: true },
    transportRequest: { type: Object, default: null }
  },
  computed: {
    ...mapGetters(['contactInfo']),
    hasSuggestedBaseCost(): boolean {
      return !!this.suggestedBaseCost
    },
    suggestedBaseCost(): number {
      return this.order?.suggestedBaseCost || 0
    },
    canShowAcceptNow(): boolean {
      return isEmpty(this.transportRequest)
    }
  }
}
